<div>
    <div class="ap-flex-row ap-justify-content-center ap-align-items-center">
        <ap-illustration name="error" width="185px" height="185px"></ap-illustration>
    </div>
    <div class="ap-display-block ap-margin-bottom-4 ap-flex-row ap-justify-content-center ap-align-items-center">
        <h1>{{ 'mijn.login.application.BrowserOutdatedModal.title' | apContent }}</h1>
    </div>
    <div class="ap-display-block ap-margin-bottom-4 ap-flex-column ap-justify-content-start ap-align-items-center ap-flex-gap-24">
        <ap-content [key]="'mijn.login.application.BrowserOutdatedModal.description'"></ap-content>
        <div
            class="ap-display-block ap-flex-row ap-flex-sm-column ap-flex-basis-sm-100 ap-justify-content-center ap-align-items-center ap-justify-content-sm-start ap-align-items-sm-stretch"
        >
            <ap-button (onClick)="toLogin()" data-bb="cancel" class="ap-flex-basis-sm-100">
                {{ 'mijn.login.application.BrowserOutdatedModal.cancel' | apContent }}
            </ap-button>
            <ap-button (onClick)="toBrowserInfo()" data-bb="browser-info" variant="secondary" class="ap-flex-basis-sm-100">
                {{ 'mijn.login.application.BrowserOutdatedModal.changeBrowser' | apContent }}
            </ap-button>
        </div>
    </div>
</div>
